import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";

export const useCanSeedDemoData = (): boolean => {
  const [enabled] = useFeatureFlag(featureFlags.epocus.seedDemoData);

  return enabled;
};
